<template>
  <div>
    <label :for="'input-line-' + _uid" v-if="showLabels">
      {{ label }}
      <span v-if="isRequired" class="text-danger">*</span>
    </label>
    <div class="input-parent" :class="inputAttributes.parentClass">
      <input
        :id="'input-line-' + _uid"
        class="form-control"
        :value="value"
        :placeholder="properties.placeholder"
        @input="handleInput"
        :disabled="disabled"
        v-bind="inputAttributes.attrs"
        v-on="inputAttributes.vOn"
        :class="[inputAttributes.class || 'form-control-sm']"
      />
    </div>
    <template v-if="showErrors">
      <p class="text-danger mb-1" v-for="(error, idx) in errorList" :key="idx">
        <b-icon-exclamation-circle></b-icon-exclamation-circle>
        <span class="ml-1">{{ error }}</span>
      </p>
    </template>
  </div>
</template>

<script>
import { processAttributes } from "@/modules/User/_utils/actions";
import validators from "../../_utils/validators";
import debounce from "lodash/debounce";

export default {
  name: "line-input-builder",
  props: {
    value: { String, default: "" },
    label: String,
    properties: Object,
    useValidation: Boolean,
    validators: Array,
    disabled: { type: Boolean, default: false },
    inputAttrs: { type: Object, default: () => ({}) },
    showLabels: { type: Boolean, default: true },
    showErrors: { type: Boolean, default: true },
  },
  data() {
    return {
      errorList: [],
      previewInputClass: "",
      previewError: "",
    };
  },
  computed: {
    inputAttributes() {
      return processAttributes(this.inputAttrs);
    },
    isRequired() {
      return (
        this.useValidation &&
        this.validators.some((e) => e.validator === "required")
      );
    },
  },
  methods: {
    checkError(input, showError = true) {
      const errors = [];
      for (const validator of this.validators) {
        const err = validators[validator.validator](input, validator);
        if (err) {
          errors.push(err);
        }
      }
      if (showError) this.errorList = errors;
      if (errors.length !== 0) {
        this.$emit("error", {
          key: this.key,
          errors,
        });
        return true;
      }
      return false;
    },
    handleInput(e) {
      this.$emit("input", e.target.value);
      this.useValidation && this.checkError(e.target.value);
    },
    handleEnter(event) {
      this.handleInput(event);
    },
    onInput: debounce(function (event) {
      this.handleInput(event);
    }, 3000),
  },
};
</script>
